<template>
   <div>
      <form-label id="previousAddress">Previous Addresses {{ addresses.length }}/3</form-label>

      <ul class="list-group" v-if="addresses.length > 0">
         <li class="list-group-item" v-for="(address, i) in addresses" :key="i">
            <div class="row">
               <div class="col-xs-9">
                  <small>{{ address | objectToCsv(['line1', 'line2', 'city', 'county',
                     'postcode']) }}</small>
                  <div class="_margin-top-10">
                     <span class="badge" style="margin-right: 10px">{{ address.years || 0 }} years</span>
                     <span class="badge">{{ address.months || 0 }} months</span>
                  </div>
               </div>

               <div class="col-xs-3 text-right">
                  <uiv-btn type="link" size="xs" @click="removeAddress(i)">
                     Remove
                  </uiv-btn>
               </div>
            </div>
         </li>
      </ul>

      <uiv-alert type="info" v-if="!$form.atLeast3Years">
         As you have lived at your current address for less than 3 years, please provide at minimum 3 years' worth of
         previous addresses. You can add up to 3 addresses
      </uiv-alert>

      <div class="form-group" v-show="!model.manually && addresses.length < 3 && addAddress">
         <div class="col-xs-12 _margin-bottom-10" v-show="!model.text">
            <form-label id="previousLookup">Postcode</form-label>
            <validation-messages label="Postcode" :$v="$v.model.postcode">
               <div class="input-group right">
                  <form-field id="previousLookup" placeholder="Search by Postcode" type="nospace"
                     v-model="model.postcode" :error="$v.model.postcode.$error"
                     @change="model.postcode = model.postcode.toUpperCase()" />

                  <div class="input-group-btn">
                     <uiv-btn type="primary" :disabled="requesting" @click="onGetAddress(model.postcode)">
                        <loader :show="requesting" />
                        Search
                     </uiv-btn>
                  </div>
               </div>
            </validation-messages>
         </div>

         <div class="col-xs-12" v-show="addressList.length">
            <form-label id="previous1Address">Select Your Previous Address</form-label>

            <search-select-list ref="lookup" id="previous1Address" :select-list="addressList" label-key="text"
               :error="$v.model.$error" @onChoose="onChooseAddress">
               {{ model.text }}
            </search-select-list>
         </div>

         <div class="col-xs-12">
            <div class="row">
               <div class="col-xs-5">
                  <uiv-btn type="link" size="xs" @click="onReset" v-show="model.text">
                     Search Again
                  </uiv-btn>
               </div>

               <div class="col-xs-7 text-right">
                  <uiv-btn type="link" size="xs" @click="model.manually = true">
                     Can't find your address?
                  </uiv-btn>
               </div>
            </div>
         </div>
      </div>

      <div v-if="model.manually">
         <div class="form-group _margin-bottom-20">
            <div class="col-sm-7">
               <form-label id="previousLine1">Address Line 1</form-label>
               <validation-messages label="Address Line 1" :$v="$v.model.line1">
                  <form-field id="previousLine1" v-model="model.line1" :error="$v.model.line1.$error" />
               </validation-messages>
            </div>
         </div>

         <div class="form-group _margin-bottom-20">
            <div class="col-sm-7">
               <form-label id="previousLine2">Address Line 2</form-label>
               <validation-messages label="Address Line 2" :$v="$v.model.line2">
                  <form-field id="previousLine2" v-model="model.line2" :error="$v.model.line2.$error" />
               </validation-messages>
            </div>
         </div>

         <div class="form-group _margin-bottom-20">
            <div class="col-sm-7">
               <form-label id="previousCity">City</form-label>
               <validation-messages label="City" :$v="$v.model.city">
                  <form-field id="previousCity" v-model="model.city" :error="$v.model.city.$error" />
               </validation-messages>
            </div>
         </div>

         <div class="form-group _margin-bottom-20">
            <div class="col-sm-7">
               <form-label id="previousCounty">County</form-label>
               <validation-messages label="County" :$v="$v.model.county">
                  <form-field id="previousCounty" v-model="model.county" :error="$v.model.county.$error" />
               </validation-messages>
            </div>
         </div>

         <div class="form-group _margin-bottom-20">
            <div class="col-sm-7">
               <form-label id="previousPostcode">Postcode</form-label>
               <validation-messages label="Postcode" :$v="$v.model.postcode">
                  <form-field id="previousPostcode" type="nospace" v-model="model.postcode"
                     :error="$v.model.postcode.$error" />
               </validation-messages>
            </div>
         </div>

         <div class="form-group _margin-bottom-20">
            <div class="col-sm-7">
               <uiv-btn type="link" size="sm" @click="model.manually = false">
                  Search By Postcode
               </uiv-btn>
            </div>
         </div>
      </div>

      <div class="form-group _margin-bottom-20" v-if="addresses.length < 3 && addAddress">
         <div class="col-xs-12">
            <form-label id="previousLengthOfResidencyYears">How long did you live at this address?</form-label>
            <div class="row">
               <div class="col-xs-6">
                  <div class="input-group right">
                     <form-field id="previousLengthOfResidencyYears" v-model="model.years" maxlength="3" type="number"
                        :error="$v.model.years.$error" @change="onTimeAtAddress" />
                     <div class="input-group-addon">years</div>
                  </div>
               </div>

               <div class="col-xs-6">
                  <div class="input-group right">
                     <form-field id="previousLengthOfResidencyMonths" v-model="model.months" maxlength="2" type="number"
                        :error="$v.model.months.$error" @change="onTimeAtAddress" />
                     <div class="input-group-addon">months</div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <div class="form-group" v-if="addAddress">
         <div class="col-xs-6">
            <uiv-btn type="default" size="sm" @click="addAddress = false">
               Cancel
            </uiv-btn>
         </div>

         <div class="col-xs-6 text-right">
            <uiv-btn type="secondary" size="sm" @click="save">
               Save
            </uiv-btn>
         </div>
      </div>

      <div class="form-group" v-if="addresses.length < 3 && !addAddress">
         <div class="col-sm-12 text-right">
            <uiv-btn type="secondary" size="sm" @click="addAddress = true; onReset()">
               Add Previous Address
            </uiv-btn>
         </div>
      </div>
   </div>
</template>

<script>
import {
   required, helpers, requiredIf, numeric
} from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
   name: 'PreviousAddressess',
   data() {
      return {
         requesting: false,
         addAddress: false,
         model: {
            manually: false,
            lengthOfResidencyInMonths: null,
            line1: null,
            line2: null,
            county: null,
            city: null,
            postcode: null,
            months: null,
            years: null
         },
         addressList: []
      };
   },
   props: {
      $form: Object
   },
   validations: {
      model: {
         years: { numeric, requiredIf: requiredIf((form) => !form.months && !form.years) },
         months: { numeric, requiredIf: requiredIf((form) => !form.months && !form.years) },
         line1: { requiredIf: requiredIf((form) => !form.manually) },
         line2: { requiredIf: requiredIf((form) => form.manually) },
         city: { requiredIf: requiredIf((form) => !form.manually) },
         county: { requiredIf: requiredIf((form) => form.manually) },
         postcode: {
            required,
            regex: helpers.regex('postcode', /^([A-Z][A-HJ-Y]?[0-9][A-Z0-9]? ?[0-9][A-Z]{2}|GIR ?0A{2})$/)
         }
      }
   },
   computed: {
      ...mapState({
         addresses: ({ personal_details_address }) => personal_details_address.previousAddresses
      })
   },
   methods: {
      ...mapActions({
         findAddresses: 'lookups/getAddresses'
      }),
      onReset() {
         this.model = {
            manually: false,
            lengthOfResidencyInMonths: null,
            line1: null,
            line2: null,
            county: null,
            city: null,
            postcode: null,
            months: null,
            years: null
         };

         this.addressList = [];
         this.$forceUpdate();
      },
      async onGetAddress(postcode) {
         this.$v.model.postcode.$touch();
         if (this.$v.model.postcode.$invalid) return;
         this.requesting = true;
         this.addressList = await this.findAddresses(postcode);
         this.requesting = false;
      },
      onChooseAddress(selected) {
         this.model.line1 = selected.addressLine1;
         this.model.line2 = selected.addressLine2;
         this.model.city = selected.city;
         this.model.county = selected.county;
         this.model.postcode = selected.postcode.replace(' ', '');
         this.model.text = selected.text;

         this.$forceUpdate();
      },
      onTimeAtAddress() {
         const years = (y) => parseInt(y || 0);
         const months = (m) => parseInt(m || 0);
         const total = (years(this.model.years) * 12) + months(this.model.months);

         this.model.lengthOfResidencyInMonths = total;
      },
      save() {
         this.$v.$touch();

         if (this.$v.$invalid) return;
         this.$v.$reset();
         this.addresses.push(this.model);

         this.addAddress = false;
         this.$refs.lookup.onReset();
      },
      removeAddress(i) {
         this.addresses.splice(i, 1);
      }
   }
};
</script>

<style lang="scss"></style>
